<div class="base-content">
  <app-sidebar-menu></app-sidebar-menu>

  <div class="content-wrapper">
    <app-header></app-header>
    <router-outlet></router-outlet>
  </div>

  <app-record-details-widget></app-record-details-widget>
</div>

<app-lock-screen-dialog [show]="lockScreen$ | async"
                        [focusPin]="focusPin"
                        (pinComplete)="unlockScreen($event)"
                        (forgotPin)="openResetPinDialog()"
></app-lock-screen-dialog>

<app-reset-pin-dialog [show]="showResetPinDialog"
                      (cancel)="closeResetPinDialog()"
                      (afterUpdate)="afterPinUpdated($event)"
></app-reset-pin-dialog>
<app-pending-transaction-message class="center" [show]="lockScreen$ | async"></app-pending-transaction-message>